module.exports = __webpack_public_path__ + "static/media/like_clicked.e0ab7d03.png";